import { useState, useEffect } from "react";
import { motion } from "framer-motion";
import { getMobileAppDesigns, type DesignAsset } from "@/services/localAssets";
import { Skeleton } from "@/components/ui/skeleton";
import { Link } from "react-router-dom";

export default function MobileAppGallery() {
  const [designs, setDesigns] = useState<DesignAsset[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    try {
      setIsLoading(true);
      const mobileAppDesigns = getMobileAppDesigns();
      setDesigns(mobileAppDesigns);
    } catch (err) {
      console.error("Error fetching mobile app designs:", err);
    } finally {
      setIsLoading(false);
    }
  }, []);

  // Image error handler
  const handleImageError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    console.warn("Image failed to load:", e.currentTarget.src);
    e.currentTarget.src = "https://via.placeholder.com/300x300?text=Image+Not+Found";
  };

  return (
    <div className="py-20 px-4 bg-accent-navy min-h-screen">
      <div className="max-w-7xl mx-auto">
        <div className="flex justify-between items-center mb-10">
          <h1 className="text-4xl font-bold text-white">Mobile App Designs</h1>
          <Link 
            to="/" 
            className="coral text-coral px-4 py-2 rounded hover:coral transition-colors"
          >
            Back to Home
          </Link>
        </div>

        {isLoading ? (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {Array(8)
              .fill(0)
              .map((_, index) => (
                <div key={index} className="rounded-lg overflow-hidden">
                  <div className="h-[400px]">
                    <Skeleton className="h-full w-full" />
                  </div>
                </div>
              ))}
          </div>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {designs.map((design) => (
              <motion.div
                key={design.id}
                whileHover={{ scale: 1.03 }}
                className="rounded-lg overflow-hidden shadow-lg"
              >
                <div className="h-[400px] rounded-lg overflow-hidden">
                  <img
                    src={design.url}
                    alt={design.title}
                    className="object-contain w-full h-full"
                    onError={handleImageError}
                  />
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
} 